import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchExpenses, addExpense } from '../../store/slices/expenseSlice';
import { useParams } from 'react-router-dom';

const AdminExpenses = () => {
    const dispatch = useDispatch();
    const { eventId } = useParams(); // Supongamos que el ID del evento viene en la URL
    const { expenses, loading, error } = useSelector((state) => state.expenses);
    const [expenseData, setExpenseData] = useState({ description: '', amount: '' });

    useEffect(() => {
        dispatch(fetchExpenses(eventId));
    }, [dispatch, eventId]);

    const handleInputChange = (e) => {
        setExpenseData({ ...expenseData, [e.target.name]: e.target.value });
    };

    const handleAddExpense = (e) => {
        e.preventDefault();
        dispatch(addExpense({ ...expenseData, event: eventId }));
        setExpenseData({ description: '', amount: '' });
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <h1 className="text-3xl font-bold">Gestionar Gastos</h1>

            <form onSubmit={handleAddExpense} className="mt-6">
                <h2 className="text-2xl font-semibold mb-4">Agregar Gasto</h2>
                <div className="mb-4">
                    <label className="block">Descripción</label>
                    <input
                        type="text"
                        name="description"
                        value={expenseData.description}
                        onChange={handleInputChange}
                        className="border px-4 py-2 w-full"
                        required
                    />
                </div>
                <div className="mb-4">
                    <label className="block">Monto</label>
                    <input
                        type="number"
                        name="amount"
                        value={expenseData.amount}
                        onChange={handleInputChange}
                        className="border px-4 py-2 w-full"
                        required
                    />
                </div>
                <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded">
                    Agregar Gasto
                </button>
            </form>

            <h2 className="text-2xl font-semibold mt-8">Lista de Gastos</h2>
            {loading ? (
                <p>Cargando gastos...</p>
            ) : error ? (
                 <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
                <strong>Error:</strong>{' '}
                {typeof error === 'object' ? error.message || JSON.stringify(error) : error}
            </div>
            ) : (
                <table className="min-w-full mt-4">
                    <thead>
                        <tr>
                            <th className="px-4 py-2">Descripción</th>
                            <th className="px-4 py-2">Monto</th>
                            {/* Agrega acciones para eliminar gastos */}
                        </tr>
                    </thead>
                    <tbody>
                        {expenses.map((expense) => (
                            <tr key={expense._id}>
                                <td className="border px-4 py-2">{expense.description}</td>
                                <td className="border px-4 py-2">${expense.amount}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default AdminExpenses;
